import { createContext, type ReactNode } from 'react'
import type { UserInfosResponse } from '~/api/queries/user'
import type { ApplicantModalType, AsideActionPosition } from '~/types/global'

export const AuthContext = createContext<UserInfosResponse | null>(null)

export type AsideActionOptions = {
  action: ReactNode
  isWide?: boolean
  position?: AsideActionPosition
  availablePositions?: AsideActionPosition[]
  /** Action restored when this one closes (quick action opened from another aside). */
  returnTo?: ReactNode
}

export const AsideActionContext = createContext<{
  asideAction: ReactNode | null
  isWide: boolean
  position: AsideActionPosition
  availablePositions: AsideActionPosition[]
  isDirty: boolean
  resetOnClose: boolean
  setAsideAction: ({
    action,
    isWide,
    position,
    availablePositions,
    returnTo
  }: AsideActionOptions) => void
  setPosition: (position: AsideActionPosition) => void
  setIsDirty: (isDirty: boolean) => void
  setResetOnClose: (resetOnClose: boolean) => void
  resetAction: () => void
  clearAction: () => void
}>({
  asideAction: null,
  isWide: false,
  position: 'sidebar',
  availablePositions: ['sidebar'],
  isDirty: false,
  resetOnClose: true,
  setPosition: () => {},
  setAsideAction: () => {},
  setIsDirty: () => {},
  setResetOnClose: () => {},
  resetAction: () => {},
  clearAction: () => {}
})

export const ApplicantModalContext = createContext<{
  applicantCollection: ApplicantModalType[]
  setApplicantCollection: (applicants: ApplicantModalType[]) => void
  applicantCurrentId: number | null
  setApplicantCurrentId: (id: number | null) => void
  openNextAction: boolean
  setOpenNextAction: (openNextAction: boolean) => void
}>({
  applicantCollection: [],
  setApplicantCollection: () => {},
  applicantCurrentId: null,
  setApplicantCurrentId: () => {},
  openNextAction: false,
  setOpenNextAction: () => {}
})

export const HoverInfoContext = createContext<{ close: () => void }>({
  close: () => {}
})
